/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付情報
 */
export interface Szoa304aRequestAceptInfo { 
    /**
     * 受付番号：数字
     */
    aceptNo?: string;
    /**
     * 受付履歴番号：数字
     */
    aceptRrkno?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 更新区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C400010」のユーザコードを設定
     */
    updateDiv: string;
    /**
     * 内部お客さま番号：数字
     */
    visitNo?: string;
    /**
     * 使用お客さま番号：数字
     */
    logicDeviceNo?: string;
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo?: string;
    /**
     * 請求お客さま番号：数字
     */
    recptFixNo?: string;
    /**
     * 同時受付番号：数字
     */
    simltnAceptNo?: string;
    /**
     * 受付種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C401010」のユーザコードを設定
     */
    aceptClsfy: string;
    /**
     * 受付日付：日付(yyyyMMdd)
     */
    aceptDate: string;
    /**
     * 受付時刻：時刻(HHmm)
     */
    aceptHms: string;
    /**
     * 受付担当組織番号：英数字
     */
    aceptSosikiCode?: string;
    /**
     * 受付担当社員番号：英数字
     */
    aceptStaffNo?: string;
    /**
     * 託送連絡要否フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C401030」のユーザコードを設定
     */
    cnscncYhiflg?: string;
    /**
     * 外部接続番号：英数字
     */
    extCnnctNo?: string;
}

